'use strict';

require('./AddressBookService.js');

function AddressBookCtrl(
  $scope,
  contacts,
  growl,
  translations,
  CompanyService,
  AddressBookService
) {
  $scope.contacts = contacts;

  $scope.addContact = function() {
    $scope.newContact = {
      "name":      "",
      "companies":   [],
      "email":     "",
      "telephone": "",
      "note":      ""
    };

    $scope.contacts.unshift($scope.newContact);
  };

  $scope.searchCompaniesContact = function(filterCompanies, contact) {
    var nonCompaniesPromise;
    $scope.contacts[$scope.contacts.indexOf(contact)].nonCompanies = [];
    var p = CompanyService.query({limit: 21, q: filterCompanies}).$promise.then(function(companies){
      return companies.filter(function(item) {
        return !$scope.contacts[$scope.contacts.indexOf(contact)].companies.some(function(company) {
          return item.id === company.id;
        });
      });
    }).then(function(nonCompanies) {
      if(nonCompaniesPromise === p) {
        $scope.contacts[$scope.contacts.indexOf(contact)].nonCompanies = nonCompanies;
      }
    });
    nonCompaniesPromise = p;
  };

  $scope.saveContact = function(contact) {
    if (contact.id) {
      AddressBookService.update(contact);

      growl.addSuccessMessage(translations['address-book.update-successful']);
    }
    else {
      AddressBookService.insert(contact).$promise.then(function(resp) {
        $scope.newContact = null;

        contact.id = resp.id;

        growl.addSuccessMessage(translations['address-book.insert-successful']);
      });
    }
  };

  $scope.removeContact = function(contact) {
    if (contact.id) {
      AddressBookService.delete(contact).$promise.then(function() {
        $scope.contacts.splice($scope.contacts.indexOf(contact), 1);

        growl.addSuccessMessage(translations['address-book.delete-successful']);
      });
    }
    else {
      $scope.newContact = null;
      $scope.contacts.splice($scope.contacts.indexOf(contact), 1);
    }
  };

  $scope.searchCompanies = function(filterText) {
    CompanyService.query({limit: 21, q: filterText}).$promise.then(function(companies){
      $scope.resultCompanies = companies;
    });
  };

  $scope.searchContacts = function(companyId){
    AddressBookService.query({companyId: companyId}).$promise.then(function(contacts){
      $scope.contacts = contacts;
    });
  };
}

AddressBookCtrl.resolve = {
  contacts: ['AddressBookService', function(AddressBookService) {
    return AddressBookService.query().$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'address-book.insert-successful',
      'address-book.update-successful',
      'address-book.delete-successful'
    ]);
  }]
};

module.exports = AddressBookCtrl;

angular.module('dokiv')
  .controller('AddressBookCtrl', [
    '$scope',
    'contacts',
    'growl',
    'translations',
    'CompanyService',
    'AddressBookService',
    AddressBookCtrl
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/AddressBookCtrl.js
// module id = 55
// module chunks = 0